export default "__VITE_PUBLIC_ASSET__fd65bcb3__"